export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '&',
  },
  {
    name: 'link_heading',
    label: 'Link Heading',
    selector: '& .link-heading',
  },
  {
    name: 'link',
    label: 'Link',
    selector: '& a',
  },
];
